/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UpdateManyData } from './updateManyData';


export interface UpdateAssetManyDto { 
    ids: Array<string>;
    updateData: UpdateManyData;
}

